/*
 * Dorellini PDP — Amazon-style hover zoom on the main image.
 * Binds to each .product-media-constraint-wrapper inside
 * .product-information__media. Disabled on touch and <769px.
 * Idempotent: data-zoom-bound guard prevents double-binding,
 * including after a flavor AJAX swap that dispatches
 * `dorellini:product:swapped`.
 */
(function () {
  function attachZoom(container) {
    var img = container.querySelector('img');
    if (!img || container.dataset.zoomBound === '1') return;
    container.dataset.zoomBound = '1';

    container.addEventListener('mouseenter', function () {
      if (!window.matchMedia('(hover: hover)').matches) return;
      if (window.innerWidth < 769) return;
      container.classList.add('is-zooming');
    });

    container.addEventListener('mouseleave', function () {
      container.classList.remove('is-zooming');
      img.style.transformOrigin = 'center center';
    });

    container.addEventListener('mousemove', function (e) {
      if (!container.classList.contains('is-zooming')) return;
      var rect = container.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      img.style.transformOrigin = x + '% ' + y + '%';
    });
  }

  function initAllZooms() {
    var containers = document.querySelectorAll(
      '.product-information__media .product-media-constraint-wrapper'
    );
    containers.forEach(attachZoom);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllZooms);
  } else {
    initAllZooms();
  }

  document.addEventListener('dorellini:product:swapped', initAllZooms);
  document.addEventListener('shopify:section:load', initAllZooms);
})();
